// core
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  Self,
  input,
} from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

// pipes
import { FormControlPipe } from '@shared/pipe';

// schemas
import { IFormCustomClass } from '@data/schema';

@Component({
  selector: 'app-select-input',
  standalone: true,
  imports: [CommonModule, NgSelectModule, ReactiveFormsModule, FormControlPipe],
  templateUrl: './select-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectInputComponent implements ControlValueAccessor {
  label = input.required<string>();
  placeholder = input<string>('Select an option');
  list = input<any[]>([]);
  labelField = input<string>('label');
  valueField = input<string>('value');
  multiple = input<boolean>(false);
  searchable = input<boolean>(false);
  clearable = input<boolean>(false);
  appendTo = input<string>();
  inputRequiredIndicatorEnabled = input<boolean>(false);
  testAutomationSelectorName = input<string>();
  customClasses = input<IFormCustomClass>({
    formGroup: 'mb-3',
    label: 'form-label fw-medium mb-2',
    input: '',
  });

  @Output() onOptionSelect = new EventEmitter<any>();
  @Output() onOptionClear = new EventEmitter<void>();

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  writeValue(_obj: any): void {}
  registerOnChange(_fn: any): void {}
  registerOnTouched(_fn: any): void {}

  onChange($event: any) {
    this.onOptionSelect.emit($event);
  }

  onClear() {
    this.onOptionClear.emit();
  }
}
